export const translations = {
  en: {
    // Hero
    heroBadge: "Friendly Cornish sea angling club since 1962",
    heroDesc: "A welcoming Cornwall club for sea anglers of all experience levels, with regular fixtures, club records, competitions, community events, and a strong catch-and-release ethos.",
    heroAffiliated: "Affiliated to the Angling Trust",

    // Hero card
    whyJoin: "Why join our club?",
    whyJoinHeading: "What Redruth Sea Angling Association offers",

    // Club benefits
    benefits: [
      "Regular shore and boat competitions throughout the year",
      "Friendly Cornish Sea Angling community welcoming new members",
      "Club records, trophies, and competition results",
      "Junior anglers and beginners welcome",
      "Strong conservation and catch-and-release ethos",
      "Organised social events and club gatherings",
      "Regular meetings and social activities",
      "Good support for new members and those new to sea angling",
    ],

    // About section
    aboutLabel: "About the club",
    aboutHeading: "An introduction to the Redruth Sea Angling Association",

    card1Heading: "Cornwall Sea Fishing Club – Established 1962",
    card1Para1: "Founded in 1962, the Redruth Sea Angling Association is one of Cornwall's longest-standing sea fishing clubs. For over six decades, we've brought together anglers from across the county, creating a friendly and inclusive community for anyone passionate about sea fishing.",
    card1Para2: "The RSAA is proudly affiliated to the Angling Trust, the national governing body for all fishing in England.",

    card2Heading: "Shore & Boat Fishing in Cornwall",
    card2Para1: "Members enjoy a wide variety of fishing throughout the year, including shore competitions, boat trips, species hunts, and the popular Colin Rule series.",
    card2Para2: "We also run multiple month-long competitions with different formats, keeping the season varied, competitive, and exciting for anglers of all abilities.",
    card2Para3: "We also recognise outstanding catches through our Best Fish of the Month awards, presented separately for shore and boat fishing — a great way to celebrate personal bests and keep the competitive spirit alive all year round.",

    card3Heading: "Community, Meetings & Guest Speakers",
    card3Para1: "Our monthly meetings are at the heart of the club, giving members the chance to connect, share catches, and plan upcoming trips.",
    card3Para2: "We regularly host guest speakers, offering valuable insights, techniques, and local knowledge to help anglers improve and stay up to date with what's being caught around Cornwall.",

    card4Heading: "Conservation & Catch-and-Release",
    card4Para1: "We take conservation seriously. Alongside historic official records dating back to the 1960s, we actively promote catch-and-release to help protect Cornish sea fish stocks for future generations.",
    card4Para2: "By encouraging responsible angling practices, we aim to preserve the quality of local fishing for years to come.",

    // Our story
    storyLabel: "Our story",
    storyPara1: "Redruth Sea Angling Association, nestled in the heart of West Cornwall, was established in 1962 by local anglers from Redruth. Over the decades, it has grown into one of Cornwall's most respected sea angling clubs, with a proud record of achievements and a strong local reputation.",
    storyPara2: "At its peak, the club had over 100 members. While numbers dipped in recent years, we're excited to have seen a revival — once again reaching around 100 members. Today, we maintain vibrant shore and boat sections, and our junior section is growing rapidly, representing the future of our club.",
    storyPara3: "We are committed to fostering a friendly, welcoming environment where lasting friendships are formed. Members support one another, sharing knowledge, techniques, and experiences to enhance everyone's angling skills.",
    storyPara4: "Our monthly meetings bring members together to connect, learn, and plan. These gatherings often feature guest speakers, offering valuable insights, and provide opportunities to arrange trips, share updates on recent catches, and gain practical knowledge that enriches the angling experience for all.",
  },

  kw: {
    // Hero
    heroBadge: "Klowses gwithyas mor Kernowek, teg ha dynerghus, dhyworth 1962",
    heroDesc: "Kowethas Kernowek dynnarghus rag pyskessores mor a bub level profyans, gans omwedhyansow resek, kovskrifsow klowses, strif, hwarvosow gemeneth, ha gnas krev a dhalhennans ha delivrans.",
    heroAffiliated: "Kevrennys dhe'n Omdheldh Pyskessa",

    // Hero card
    whyJoin: "Prag omjunya agan klowses?",
    whyJoinHeading: "Pyth a wra Keseyans Pyskessa Mor Rysrudh",

    // Club benefits
    benefits: [
      "Omwedhyansow treth ha skath yn fenowgh dres an vledhen",
      "Gemeneth Pyskessa Mor Kernowek, golowekhes, ow dynnargh eseli nowydh",
      "Kovskrifsow klowses, kelyk ha disqueyansow omwedhyans",
      "Pyskessores yowynk ha dallethyoryon dynnarghys",
      "Gnas krev a wiasans ha dalhennans-ha-delivrans",
      "Hwarvosow soeyal arlukyes ha kuntellyow klowses",
      "Kuntellow rag ha gweythyansow soeyal",
      "Skoodhyans da rag eseli nowydh ha re nowydh dhe byskessa mor",
    ],

    // About section
    aboutLabel: "A-dro dhe'n klowses",
    aboutHeading: "Kowsow a-dro dhe Geseyans Pyskessa Mor Rysrudh",

    card1Heading: "Klowses Pyskessa Mor Kernow – Sylfennys 1962",
    card1Para1: "Sylfennys yn 1962, yma Keseyans Pyskessa Mor Rysrudh yn mysk klowsesyow pyskessa mor hirha Kernow. Dres moy es hwegh degvedh, re wrussyn ni dos ha bos yn kever pyskessores dhyworth pub rann an konteth, ha formya gemeneth golowekhes ha gynnosrannow rag pynag a vo ankevis a-dro dhe byskessa mor.",
    card1Para2: "Yma an RSAA kevrennys gans pris dhe'n Omdheldh Pyskessa, an korf rewlans genedhlethel rag oll pyskessa yn Pow Sows.",

    card2Heading: "Pyskessa Treth ha Skath yn Kernow",
    card2Para1: "Yma eseli ow joydya lyes sort pyskessa dres an vledhen, ynkludhys omwedhyansow treth, viajow skath, helghow spesys, ha'n reden bopuler Colin Rule.",
    card2Para2: "Yth eson ni ynwedh ow redya lyes omwedhyans hir-vis gans furvow dyffrans, ow holya an seson ha gwul an jy lies sort, kestrivek, ha hwethys rag pyskessores a bub abylyta.",
    card2Para3: "Yth eson ni ynwedh ow aswon dalhennansow arbednek der agan gobrennow Pysk Gwella an Mis, presentys dyffrans rag pyskessa treth ha skath — fordh veur dhe selwel rekordys personel ha holya an sperys kestrivek yn byw dres oll an vledhen.",

    card3Heading: "Gemeneth, Kuntellow ha Klappyoryon Vysytya",
    card3Para1: "Yma agan kuntellow mis-war-vis ow bos orth kredhow an klowses, ow ri dhe eseli an chons dhe geskewsel, ranna dalhennansow, ha planadow viajow a dheu.",
    card3Para2: "Yth eson ni ow waytya klappyoryon vysytya yn fenowgh, ow profya kevaithow fethus, teknikow, ha godhvos leel dhe skoodhya pyskessores dhe wella ha hware yn keth gans pyth a gaffer yn tro Kernow.",

    card4Heading: "Gwiasans ha Dalhennans-ha-Delivrans",
    card4Para1: "Yth eson ni owth omgemeres gwiasans yn few. Kevro ha kovskrifsow historigel dalhennans-ha-gwitha ow mos yn kof dhe'n 1960ow, yth eson ni ow promowtya aktif dalhennans-ha-delivrans dhe waydya dhe witha stokys pysk mor Kernowek rag henasow a dheu.",
    card4Para2: "Dre ankevsi praktisyow pyskessa govedhus, y hwrussyn ni towla gwitha an yehes a byskessa leel rag bledhenyow a dheu.",

    // Our story
    storyLabel: "Agan hwedhel",
    storyPara1: "Keseyans Pyskessa Mor Rysrudh, settyes yn kredhow Kernow Goth, re beu sylfennys yn 1962 gans pyskessores leel a Rysrudh. Dres an dekennow, res ywa tewi yn mysk klowsesyow gwithyas mor moyha respektys Kernow, gans kovnans pryv a hwarvosow ha son leel krev.",
    storyPara2: "Yn y bik, ysa an klowses gans moy es 100 ael. Kyn falias an nyver yn bledhenyow diwettha, yth on ni lowen dhe weles dasserghyans — ow tos ha bos yn kever 100 ael arta. Hedhyw, yth eson ni ow sensy rannow treth ha skath byw, ha'n rann yowynk ow tevi yn uskis, ow representya towlen agan klowses.",
    storyPara3: "Yth eson ni omprennys dhe fosta gemeneth golowekhes, dynnarghus, le may feurmer keskowethyansow hirdhew. Yma eseli ow skoodhya y gila, ow ranna godhvos, teknikow, ha profyansow dhe wella skensow gwithyas rag oll.",
    storyPara4: "Yma agan kuntellow mis-war-vis ow dos ha bos yn kever eseli dhe geskewsel, dyski, ha planadow. Yn fenowgh yma klappyoryon vysytya orth an kuntellow ma, ow profya kevaithow fethus, ha ow ri chonsow dhe arlukya viajow, ranna nowodhow a-dro dhe dhalhennansow diwettha, ha kolgordha godhvos pregel ow pyski an profyans gwithyas rag oll.",

    // Generic UI string lookup table — used by the tt() helper in App.js to translate
    // static labels, headings, buttons and form text throughout the home page.
    strings: {
      // Top nav
      "Home": "Tre",
      "About": "A-dro Dhyn",
      "Fixtures": "Omwedhyansow",
      "Sea Conditions": "Kessedhys Mor",
      "Current Winners": "Gwaynoryon Lemmyn",
      "Officers": "Soodhogyon",
      "Records": "Kovskrifsow",
      "Species Hunt": "Helgh Spesys",
      "Club Rules & Documents": "Rewlys ha Skrifennow an Klowses",
      "Sponsors & Merchandise": "Skoodhoryon ha Marghasva",
      "Local Services": "Servisyow Leel",
      "Angler's Tools": "Toulys an Pyskessor",
      "Media": "Media",
      "Contact": "Kestava",

      // Nav dropdown children / documents / footer links
      "C&R Records": "Kovskrifsow Dalhennans-ha-Delivrans",
      "Official Club Records": "Kovskrifsow Ofisek an Klowses",
      "Junior Records": "Kovskrifsow Yowynk",
      "Awards & Fish of Month": "Gobrennow ha Pysk an Mis",
      "Awards & Champions": "Gobrennow ha Champyons",
      "Meeting Agenda & Minutes": "Agenda ha Kovskrifow Kuntellow",
      "Weighing Scales Policy": "Polici Skalys Poesa",
      "Weighing & Measuring Procedures": "Fordhow Poesa ha Musura",
      "Weighing & Measuring": "Poesa ha Musura",
      "RSAA Safeguarding Policy": "Polici Gwithyans RSAA",
      "Safeguarding Policy": "Polici Gwithyans",
      "Club Rules": "Rewlys an Klowses",
      "RSAA Constitution": "Konstitussyon RSAA",
      "Club Constitution": "Konstitussyon an Klowses",
      "Club Fixtures": "Omwedhyansow an Klowses",
      "Boat Risk Assessments": "Ammontyansow Peryll Skath",
      "Boat Risk Assessment": "Ammontyans Peryll Skath",
      "Boat Safety Report": "Derivas Salowder Skath",
      "Shore Risk Assessment": "Ammontyans Peryll Treth",
      "Shore Fishing Risk Assessment": "Ammontyans Peryll Pyskessa Treth",
      "Month Long Boat Competitions": "Omwedhyansow Skath Mis-hir",
      "Month Long Shore Competitions": "Omwedhyansow Treth Mis-hir",
      "Month Long Boat Comps": "Kompow Skath Mis-hir",
      "Month Long Shore Comps": "Kompow Treth Mis-hir",
      "RSAA Species Hunt Rules": "Rewlys Helgh Spesys RSAA",
      "Species Hunt Rules": "Rewlys Helgh Spesys",
      "Club Sponsors": "Skoodhoryon an Klowses",
      "Club Merchandise": "Marghasva an Klowses",
      "Specimen Calculator": "Reknores Spesymen",
      "Competitions Leaderboard Calculator": "Reknores Tabel Ledyoryon",
      "Competition Leaderboard": "Tabel Ledyoryon Omwedhyans",
      "Angler Safety & what3words": "Salowder Pyskessor ha what3words",
      "Just Tides": "Unnyk Tredannow",
      "Sea Views — Live Webcams": "Golokvaow Mor — Kamerys Byw",
      "Detailed Weather Forecast": "Dyskryf Gwedher Manylyon",
      "Detailed Weather Forecast ↗": "Dyskryf Gwedher Manylyon ↗",
      "News": "Nowodhow",
      "Gallery": "Galeri",
      "YouTube Channels": "Chanellow YouTube",

      // Header misc
      "Join": "Omjunya",
      "Add RSAA to Your Home Screen": "Keworra RSAA dhe'gas Skrin Tre",
      "Tap here": "Tich omma",
      "Join the club": "Omjunya an klowses",
      "Language": "Yeth",

      // Hero card
      "Why join our club?": "Prag omjunya agan klowses?",
      "Why Join RSAA?": "Prag Omjunya RSAA?",
      "Competitions & Fishing": "Omwedhyansow ha Pyskessa",
      "Regular shore and boat competitions, club records, trophies and leaderboard tracking.": "Omwedhyansow treth ha skath yn fenowgh, kovskrifsow klowses, kelyk ha holyans an tabel ledyoryon.",
      "Welcoming Community": "Gemeneth Dynnarghus",
      "A friendly Cornish angling community with strong support for beginners and new members.": "Gemeneth pyskessa Kernowek, teg, gans skoodhyans krev rag dallethyoryon hag eseli nowydh.",
      "Conservation Ethos": "Gnas Gwiasans",
      "Catch-and-release focused, promoting sustainable and responsible sea angling.": "Ow fokassya war dhalhennans-ha-delivrans, ow promowtya pyskessa mor sostenadow ha gwedhus.",
      "Social & Club Life": "Bewnans Soeyal ha Klowses",
      "Social evenings, club gatherings, guest speakers, and junior anglers actively encouraged.": "Gorholyow soeyal, kuntellyow klowses, klappyoryon vysytya, ha pyskessores yowynk keskerys yn fenowgh.",
      "Become a Member": "Bos Ael",
      "Join RSAA Today →": "Omjunya RSAA Hedhyw →",

      // Next competition banner
      "Next Competition": "An Omwedhyans Nessa",
      "Happening Today!": "Ow Hwarvos Hedhyw!",
      "days": "dydhyow",
      "hrs": "oures",
      "mins": "mynysow",
      "secs": "eylennow",

      // Membership section
      "Membership": "Aeleth",
      "How to join the Redruth Sea Angling Association": "Fatel omjunya Keseyans Pyskessa Mor Rysrudh",
      "Adult annual subscription": "Kevrenans bledhennek tevesik",
      "Includes club membership, liability cover, and support for general administration.": "Ynkludhys aeleth klowses, gwitha kessedhek, ha skoodhyans rag ministrasyon ollgemmyn.",
      "Junior annual subscription": "Kevrenans bledhennek yowynk",
      "Open to junior members. A parent or guardian must co-sign the membership application.": "Igor dhe eseli yowynk. Res yw dhe gams po wgorlik kesynny an applikashyon aeleth.",
      "Ready to join Redruth Sea Angling Association?": "Parys dhe omjunya Keseyans Pyskessa Mor Rysrudh?",
      "Adult membership is £15 · Junior membership is £1. Complete the form below and pay via card/bank via SumUp. Alternatively, new and prospective members are always welcome to come along to one of our meetings and pay in person.": "Aeleth tevesik yw £15 · Aeleth yowynk yw £1. Kowlwrewgh an form a-woeles ha talewgh dre gart/bank dre SumUp. Po, yma eseli nowydh ha posybel dynnarghys pub prys dhe dhos dhe onan a'gan kuntellow ha taly yn person.",
      "Start membership": "Dalleth aeleth",

      // Fixtures section
      "Upcoming fixtures calendar": "Kalendar omwedhyansow a dheu",
      "Please read: Weighing Scales Policy Notice": "Redyewgh mar pleg: Kedhlow Polici Skalys Poesa",
      "Shore Competitions": "Omwedhyansow Treth",
      "Boat Competitions": "Omwedhyansow Skath",
      "before competing": "kyns kestrivya",
      "Competition Rules": "Rewlys Omwedhyans",
      "Share": "Ranna",
      "Hide": "Kudha",
      "Show": "Diskwedhes",
      "Easter Competition": "Omwedhyans Pask",
      "Small Boats / Dinghy Competition": "Omwedhyans Skathow Byghan / Dinghy",
      "Half Day Club Boat Trip": "Viaj Skath Klowses Hanter Dydh",
      "Bream Competition": "Omwedhyans Bremm",
      "Full Day Club Boat Trip": "Viaj Skath Klowses Dydh Leun",
      "Float and Spin Competition": "Omwedhyans Fleot ha Spin",
      "Ray and Bass Competition": "Omwedhyans Reyen ha Bass",
      "Beach Competition": "Omwedhyans Treth",
      "Conger Competition": "Omwedhyans Kongr",

      // Records section
      "Records and trophies": "Kovskrifsow ha kelyk",
      "Club Records & Annual Trophies": "Kovskrifsow Klowses ha Kelyk Bledhennek",
      "Catch & Release Records": "Kovskrifsow Dalhennans-ha-Delivrans",
      "Shore and boat catch & release records for all species.": "Kovskrifsow dalhennans-ha-delivrans treth ha skath rag oll spesys.",
      "View records →": "Gweles kovskrifsow →",
      "Historic shore and boat official records dating back to the 1960s.": "Kovskrifsow ofisek istorek treth ha skath, ow mos yn kof dhe'n 1960ow.",
      "Official shore and boat records for junior members.": "Kovskrifsow ofisek treth ha skath rag eseli yowynk.",
      "Annual Trophies": "Kelyk Bledhennek",
      "See all trophies ↓": "Gweles oll an kelyk ↓",
      "Tool": "Toul",
      "CFSA Specimen Calculator": "Reknores Spesymen CFSA",
      "Check if your catch qualifies as a CFSA Specimen with a percentage score.": "Gwiryewgh mars yw agas dalhen dhe worfila avel Spesymen CFSA gans skor kansran.",
      "Open →": "Egery →",
      "Calculate competition standings, best N fish, and heaviest bag scores.": "Reknewgh sav omwedhyans, an gwella N pysk, ha'n skorys sagh poessa.",

      // Trophy category labels
      "Club Competition Trophies – Shore": "Kelyk Omwedhyans an Klowses – Treth",
      "One Day Boat Competition": "Omwedhyans Skath Unn Dydh",
      "Junior Day Competition – Shore": "Omwedhyans Dydh Yowynk – Treth",
      "Senior Shore": "Treth Hendhas",
      "Junior Shore": "Treth Yowynk",
      "Ladies Shore": "Treth Benynes",
      "Boat": "Skath",
      "Boat & Shore": "Skath ha Treth",
      "Champion Anglers": "Pyskessores Champyon",

      // Documents section
      "Rules and documents": "Rewlys ha skrifennow",
      "RSAA Club Documents": "Skrifennow Klowses RSAA",
      "All club rules, policies, and competition documents are available to download below. Click any document to open it as a PDF.": "Yma oll rewlys an klowses, policiow, ha skrifennow omwedhyans dhe gavos a-woeles. Klykkyewgh dhe bub skrif rag y egery avel PDF.",

      // Officers section
      "Club officers": "Soodhogyon an klowses",
      "RSAA Club Officers": "Soodhogyon Klowses RSAA",
      "President": "Lywydh",
      "Chairman": "Cheyrmyn",
      "Vice Chairman": "Is-Gheyrmyn",
      "Hon. Secretary": "Skrifennyas Enorys",
      "Hon.Treasurer": "Trerorer Enorys",
      "Fish Recorder": "Kovskrifer Pysk",
      "Assistant Fish Recorder": "Kescovskrifer Pysk",
      "Shore Competition Secretary": "Skrifennyas Omwedhyans Treth",
      "Boat Competition Secretary": "Skrifennyas Omwedhyans Skath",
      "Youth Officer": "Soodhek Yowynkneth",
      "Welfare Officer": "Soodhek Wolewder",
      "Cup Custodian": "Gwithyas Kuppa",
      "Social Media Secretary": "Skrifennyas Media Soeyal",
      "Conservation Officer": "Soodhek Gwiasans",
      "Webmaster": "Mester Wiasva",

      // Contact section
      "Get in touch": "Kesskewsel genen",
      "Get in touch with us using the form, by phone, or come along to one of our monthly meetings.": "Kesskewsel genen dre'n form, dre bellgowser, po dos dhe onan a'gan kuntellow mis-war-vis.",
      "Meeting venue": "Le Kuntell",
      "Some meetings may be rescheduled — members notified by email and WhatsApp": "Martesen y fydh nebes kuntellow chanjys — eseli kedhlys der ebost ha WhatsApp",
      "Telephone": "Pellgowser",
      "Honorary Secretary": "Skrifennyas Enorys",
      "Email": "Ebost",
      "Send an enquiry": "Danvon govynn",
      "Message sent — we'll be in touch soon.": "Message danvenys — ni a vydh yn kestava skon.",
      "Send another message": "Danvon message arall",
      "Your name": "Agas hanow",
      "Your email": "Agas ebost",
      "Your message": "Agas message",
      "Sorry, there was a problem sending your message. Please email": "Drok yw genen, boes kudynn ow tanvon agas message. Mar pleg ebostyewgh",
      "directly.": "yn unnyk.",
      "Send message": "Danvon message",

      // Membership application form
      "Membership Application": "Applikashyon Aeleth",
      "Please complete all details below, then proceed to payment.": "Mar pleg kowlwrewgh oll manylyon a-woeles, ena mos yn rag dhe'n taly.",
      "Adult — £15": "Tevesik — £15",
      "Junior — £1": "Yowynk — £1",
      "Full Name": "Hanow Leun",
      "Mobile Number": "Niver Mobyl",
      "Full Address including Postcode": "Chy Leun gans Kod Post",
      "Email Address": "Chy Ebost",
      "I have read and agree to the": "My re redyas hag y kesunyav gans an",
      "and the": "ha'n",
      "Complete all fields and agree to the Club Rules to unlock payment.": "Kowlwrewgh oll an gwelyow ha kesunyewgh gans Rewlys an Klowses rag dygela an taly.",
      "Pay £15 via Card / Bank": "Taly £15 dre Gart / Bank",
      "Pay £1 via Card / Bank": "Taly £1 dre Gart / Bank",
      "Pay by Bank Transfer (BACS)": "Taly dre Dreusvos Bank (BACS)",
      "Please use your name as the payment reference.": "Mar pleg usyewgh agas hanow avel referens an taly.",
      "Account name": "Hanow Akont",
      "Sort code": "Kod Sort",
      "Account number": "Niver Akont",
      "✓ Your details have been submitted — please complete your bank transfer.": "✓ Agas manylyon re beu daskorrys — mar pleg kowlwrewgh agas treusvos bank.",
      "Submit my details for BACS payment": "Daskorra ow manylyon rag taly BACS",

      // Junior membership form
      "Junior Member Details": "Manylyon Ael Yowynk",
      "Junior membership is open to members aged": "Yma aeleth yowynk igor dhe eseli a oos",
      "under 16 on 1st January": "yn dan 16 dhe'n 1ves a Genver",
      "on 1st January": "dhe'n 1ves a Genver",
      "Junior's Full Name": "Hanow Leun an Yowynk",
      "Junior's Mobile (if applicable)": "Mobyl an Yowynk (mars usy)",
      "Junior's Date of Birth": "Dydh Genesigeth an Yowynk",
      "eligible for junior membership.": "gwiw rag aeleth yowynk.",
      "not eligible for junior membership.": "nag yw gwiw rag aeleth yowynk.",
      "Parent / Guardian Details": "Manylyon Gams / Gwithyas",
      "Parent / Guardian Full Name": "Hanow Leun an Gams / Gwithyas",
      "Parent / Guardian Mobile": "Mobyl an Gams / Gwithyas",
      "Parent / Guardian Email Address": "Chy Ebost an Gams / Gwithyas",
      "I (parent/guardian) have read and agree to the": "My (kams/gwithyas) re redyas hag y kesunyav gans an",
      "on behalf of the junior member.": "a-barth an ael yowynk.",
      "Please use the junior member's name as the payment reference.": "Mar pleg usyewgh hanow an ael yowynk avel referens an taly.",

      // Catches slideshow
      "Members' catches": "Dalhennow eseli",
      "Latest from the club": "Diwettha dhyworth an klowses",
      "Members competing in": "Yma eseli ow kestrivya yn",
      "competitions must read the": "res dhedha redya an",

      // Facebook / gallery
      "Visit our Facebook Group": "Visytyewgh agan Bagas Facebook",
      "Latest RSAA News from FaceBook": "Nowodhow Diwettha RSAA dhyworth FaceBook",
      "Photo Gallery": "Galeri Fotos",
      "Photos from the Redruth Sea Angling Association Facebook page": "Fotos dhyworth folen Facebook Keseyans Pyskessa Mor Rysrudh",

      // Footer
      "Quick Links": "Kevrennow Uskis",

      // Disclaimer
      "Website Disclaimer": "Notyans Diskwithyans an Wiasva",
      "The information provided on this website is for general guidance only and is published in good faith. While we make every effort to keep content accurate and up to date, we make no warranties regarding its completeness, reliability, or accuracy.": "Yma an kedhlow res war an wiasva ma rag towl ollgemmyn yn unnyk, ha publysys yn fedh da. Kyn hwren agan gwella dhe witha kontent ewn ha hedhyw, ny wren nyni garantis vyth a-dro dh'y gowlder, y grygyansgor, po y ewnder.",
      "Any action you take based on the information found on this website is strictly at your own risk. The club accepts no responsibility for any loss, damage, injury, or inconvenience arising from reliance on this information or from participation in club activities.": "Pynag ober a wrewgh, selys war an kedhlow kevys war an wiasva ma, yw yn tien orth agas peryll agas honan. Ny wra an klowses accepya kessedhek vyth rag kolles, damach, poenva, po anesyans vyth ow tos dhyworth fydhyans war an kedhlow ma po dhyworth part yn gwriansow an klowses.",
      "This website may include links to external websites. While we aim to provide links to useful and reputable sources, we have no control over the content or practices of these sites and accept no responsibility for them.": "Yma possybyl bos kevrennow yn'n wiasva ma dhe wiasvaow diwar. Kyn hwren towla ri kevrennow dhe fentynyow dader ha res, nyns eus genen rewl vyth war gontent po usadow an wiasvaow ma, ha ny wren accepya kessedhek vyth ragdha.",
      "Members and visitors are responsible for their own safety, equipment, and compliance with local fishing regulations, tides, and weather conditions at all times.": "Yma eseli ha visytoryon kessedhek rag aga salowder aga honan, aga daffar, ha kesunyans gans rewlys pyskessa leel, tredannow, ha kessedhys gwedher, pub prys.",
      "Competitions and Events": "Omwedhyansow ha Hwarvosow",
      "Participation in club competitions and events is entirely at the member's own risk. It is the responsibility of each participant to ensure they are fishing safely, within the law, and in accordance with club rules. The club accepts no liability for personal injury, loss or damage to equipment, or any incidents that may occur before, during, or after club events.": "Yma kemeryans yn omwedhyansow ha hwarvosow an klowses yn tien orth peryll an ael y honan. Yth yw kessedhek pub kevrennor dhe surhe y vos ow pyskessa yn salow, a-ji dhe'n laghys, hag herwydh rewlys an klowses. Ny wra an klowses accepya kessedhek vyth rag poenva personel, kolles po damach dhe dhaffar, na hwarvosow vyth a alsa hwarvos kyns, dres, po wosa hwarvosow an klowses.",
      "A great Cornish Club for Great Cornish Anglers.": "Klowses Kernowek meur rag Pyskessores Kernowek Meur.",
    },
  },
};
